import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { typeScale } from '@/shared/styles/typography'

// 資料の部品で共有する文字の形 (一覧・panel・行)

// 注記の 1 行 (読めなかった・まだ入っていない・断られた理由・送れませんでした)
export const noteSx = {
  ...typeScale.label,
  color: colorTokens.fg.muted,
} as const

// 文字の釦 (反映する・もう一度・端末に保存・一覧の読み直し。icon で一意に言えない操作だけ)。
// 注記の文と同じ行・同じ字格で並べる (別の箱にすると文と baseline がずれる)
export const textActionSx = {
  ...typeScale.label,
  color: colorTokens.fg.muted,
  p: 0,
  border: 'none',
  bgcolor: 'transparent',
  cursor: 'pointer',
  fontFamily: 'inherit',
  '&:hover': { color: colorTokens.fg.default },
  '&:disabled': { color: colorTokens.fg.faint, cursor: 'default' },
} as const
